import React from 'react';
import { Box } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Public/Header';
import Footer from '../components/Public/Footer';
import ConsentBanner from '../components/Public/ConsentBanner';
import PricingTable from '../components/Public/PricingTable';
import FeatureMatrix from '../components/Public/FeatureMatrix';
import CTASection from '../components/Public/CTASection';
import FAQ from '../components/Public/FAQ';
import { PRICING_FAQ, SITE, PRICING } from '../config/site';

export default function PricingPage() {
  const softwareApplicationSchema = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: SITE.name,
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    offers: PRICING.plans.map((plan) => ({
      '@type': 'Offer',
      name: plan.name,
      price: plan.price,
      priceCurrency: 'USD',
    })),
  };

  return (
    <>
      <Helmet>
        <title>Pricing - {SITE.name}</title>
        <meta
          name="description"
          content="Simple, transparent pricing for meeting transcription. Start free with 60 minutes. Upgrade to Starter ($10/mo) or Team ($49/mo) for more features."
        />
        <link rel="canonical" href={`https://${SITE.domain}/pricing`} />
        <script type="application/ld+json">
          {JSON.stringify(softwareApplicationSchema)}
        </script>
      </Helmet>

      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        <Box component="main" sx={{ flexGrow: 1 }}>
          <PricingTable />
          <FeatureMatrix />
          <FAQ faqs={PRICING_FAQ} title="Billing FAQ" />
          <CTASection
            title="Start Free — 60 Minutes Included"
            subtitle="No credit card required. Upgrade anytime."
            buttonText="Get Started Free"
            to="/register"
          />
        </Box>
        <Footer />
        <ConsentBanner />
      </Box>
    </>
  );
}
